import { React, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import "../../index.css";
import { useSelector, shallowEqual } from "react-redux";
import PetCard from "../pets/PetCard";
import Pagination from "./Pagination";

export const MascotasPublicadas = () => {
  const pets = useSelector((state) => state.notification.pets, shallowEqual);

  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 4;

  const sortedPets = useMemo(() => {
    if (!Array.isArray(pets)) return [];

    return [...pets].sort((a, b) => {
      const contactOrderA = a.en_contacto ? 1 : 0;
      const contactOrderB = b.en_contacto ? 1 : 0;

      if (contactOrderB !== contactOrderA) {
        return contactOrderB - contactOrderA;
      }
      const estadoA = a.estado || 0;
      const estadoB = b.estado || 0;

      return estadoA - estadoB;
    });
  }, [pets]);

  const paginatedPets = useMemo(() => {
    const lastPostIndex = currentPage * postsPerPage;
    const firstPostIndex = lastPostIndex - postsPerPage;
    return sortedPets.slice(firstPostIndex, lastPostIndex);
  }, [sortedPets, currentPage, postsPerPage]);

  return (
    <div className="flex flex-col justify-between min-h-[34rem]">
      <div className="space-y-[2rem] mb-[2rem]">
        <div className="bg-gray-100 border-l-4 border-secondary text-gray-500  p-4 rounded">
          <p className="font-main text-sm">
            <strong>¡Atención!</strong> Las mascotas con una campanita indican
            que alguien cree haber reconocido a ese amigo. Ingresá para
            confirmar o rechazar.
          </p>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-4">
        {paginatedPets.map((masc) => (
          <Link key={masc.id} to={`/mascota/${masc.id}`}>
            <PetCard data={masc} />
          </Link>
        ))}
      </div>

      {sortedPets.length > postsPerPage && (
        <div className="w-full h-fit flex items-center justify-center mt-4">
          <Pagination
            totalPosts={sortedPets.length}
            postsPerPage={postsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};

export default MascotasPublicadas;
